// test262
(262 && 0);
